// extracted by mini-css-extract-plugin
export default {"root":"_1ShLi","text-block":"_1J37T","textBlock":"_1J37T","prefix":"_2sR2u"};